<template>
  <BQdtCard
    name="imexTitle"
    type="header-item"
  />
</template>

<script>
import { BQdtCard } from '@/components/blocks'

export default {
  name: 'ImportExportHeader',

  components: { BQdtCard },
}
</script>
